import { LazyLoader } from "@NextSkyTheme/lazy-load";
import * as NextSkyTheme from "@NextSkyTheme/global";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryBtn) return;
    var isVisible = true;
    window.addEventListener("scroll", function () {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
            document.documentElement.classList.remove("show-sticky-cart-active");
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
            document.documentElement.classList.add("show-sticky-cart-active");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
          document.documentElement.classList.add("show-sticky-cart-active");
        }
      }
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
  initProductRatingLinks();
});
infoGallerySlide();

/** Keep theme PDP price in sync with the selected RAPI pack. */
function syncRapiPackPrice() {
  const bar = document
    .querySelector(".rapi-bundles__bar input:checked")
    ?.closest(".rapi-bundles__bar");
  if (!bar) return;

  let variant;
  try {
    variant = JSON.parse(
      document.querySelector(".sec__main-product .productVariantSelected")
        ?.textContent || "null",
    );
  } catch (error) {
    return;
  }

  const unit = Number(variant?.price);
  const format =
    themeGlobalVariables?.settings?.money_format || cartStrings?.money_format;
  if (!unit || !format) return;

  // RAPI .rapi-money stays on the first variant — compute from Shopify instead.
  const text = bar.innerText.replace(/\s+/g, " ");
  const qty = Number(text.match(/(\d+)\s*-?\s*pack/i)?.[1] || 1);
  const discount = Number(text.match(/(\d+)\s*%/)?.[1] || 0);
  const total =
    qty > 1 ? Math.round((unit * qty * (100 - discount)) / 100) : unit;
  const money = NextSkyTheme.formatMoney(total, format);
  if (!money) return;

  document
    .querySelectorAll(
      ".block-product__price .card-product-price span.price, sticky-add-cart .card-product-price span.price",
    )
    .forEach((el) => {
      if (el.textContent.trim() !== money) el.textContent = money;
    });
}

function initRapiPackPriceSync() {
  if (!document.querySelector("[data-rapi-id]")) return;

  document.addEventListener("click", (event) => {
    if (event.target.closest(".rapi-bundles__bar")) syncRapiPackPrice();
  });

  const price = document.querySelector(".block-product__price");
  if (price) {
    new MutationObserver(() => {
      const bars = [...document.querySelectorAll(".rapi-bundles__bar")];
      if (bars.findIndex((b) => b.querySelector("input:checked")) > 0) {
        syncRapiPackPrice();
      }
    }).observe(price, { childList: true, subtree: true });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initRapiPackPriceSync);
} else {
  initRapiPackPriceSync();
}

/**
 * Returns sticky header offset for in-page scroll targets.
 *
 * @returns {number}
 */
function getStickyHeaderOffset() {
  const styles = getComputedStyle(document.body);
  const headerHeight =
    parseInt(styles.getPropertyValue("--header-height"), 10) || 56;
  const barHeight =
    parseInt(styles.getPropertyValue("--height-bar"), 10) || 0;

  return headerHeight + barHeight + 8;
}

/**
 * Returns the Judge.me reviews scroll target when available.
 * Prefer the section title so widget padding is not included.
 *
 * @returns {HTMLElement | null}
 */
function getReviewsScrollTarget() {
  const reviewsRoot = document.getElementById("judgeme_product_reviews");
  if (!reviewsRoot) {
    return null;
  }

  return (
    reviewsRoot.querySelector(".jm-review-widget-minimal-header__title") ||
    reviewsRoot.querySelector(".jdgm-rev-widg__title") ||
    reviewsRoot
  );
}

/**
 * Smoothly scrolls to the Judge.me reviews section.
 *
 * @param {HTMLElement} target
 */
function scrollToReviewsSection(target) {
  const top =
    target.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset();
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  window.scrollTo({
    top,
    behavior: prefersReducedMotion ? "auto" : "smooth",
  });

  history.replaceState(null, "", "#judgeme_product_reviews");
}

/**
 * Enables PDP rating links to scroll to reviews when available.
 */
function initProductRatingLinks() {
  document.querySelectorAll("[data-scroll-to-reviews]").forEach((link) => {
    if (link.dataset.reviewsLinkInit === "true") {
      return;
    }

    link.dataset.reviewsLinkInit = "true";

    if (!link.closest(".sec__main-product")) {
      link.removeAttribute("href");
      link.classList.add("product-rating-link--inactive");
      return;
    }

    const target = document.getElementById("judgeme_product_reviews");
    if (!target) {
      link.removeAttribute("href");
      link.classList.add("product-rating-link--inactive");
      return;
    }

    link.addEventListener("click", (event) => {
      event.preventDefault();

      const scrollTarget = getReviewsScrollTarget();
      if (!scrollTarget) {
        return;
      }

      scrollToReviewsSection(scrollTarget);
    });
  });
}

document.addEventListener("DOMContentLoaded", initProductRatingLinks);
initProductRatingLinks();

/** Move the description's benefit `<ul>` beneath the price (winning A/B test). */
function moveBenefitsListAbovePurchase() {
  const list = document.querySelector(
    ".block-product__description > ul, .product-benefits-list",
  );
  if (!list) return;

  const anchor =
    document.querySelector(".product-priceuse") ||
    document.querySelector(".block-product__price");
  if (!anchor) return;

  list.classList.add("product-benefits-list");

  if (anchor.nextElementSibling === list) return;

  anchor.insertAdjacentElement("afterend", list);
}

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    moveBenefitsListAbovePurchase,
  );
} else {
  moveBenefitsListAbovePurchase();
}
